{
  "de": {
    "toast": {
      "action": {
        "email_address_taken": "Diese E-Mail-Adresse gehört bereits zu einem anderen Kontakt.",
        "failed": "Aktion fehlgeschlagen",
        "impersonate_unauthorized": "Diese Aktion ist nicht erlaubt, während Sie sich als Kunde anmelden.",
        "storage_quota_exceeded": "Speicherlimit erreicht. Löschen Sie Dateien oder kontaktieren Sie uns, um Ihren Plan zu erweitern.",
        "succeeded": "Aktion erfolgreich",
        "unprocessable": "Etwas ist schiefgelaufen, aktualisieren Sie eventuell die Seite. Wenn das Problem weiterhin besteht, wenden Sie sich bitte an uns. \nFEHLER: {error}"
      },
      "create": {
        "failed": "{itemName} konnte nicht erstellt werden",
        "succeeded": "{itemName} wurde erstellt"
      },
      "delete": {
        "failed": "{itemName} konnte nicht gelöscht werden",
        "succeeded": "{itemName} wurde gelöscht",
        "succeeded_default": "Löschen erfolgreich"
      },
      "update": {
        "failed": "{itemName} konnte nicht aktualisiert werden",
        "succeeded": "{itemName} wurde aktualisiert",
        "successfully_saved": "Erfolgreich gespeichert"
      },
      "upload": {
        "failed": "Upload fehlgeschlagen",
        "succeeded": "Hochladen erfolgreich"
      },
      "upload_document": {
        "extension_invalid": "Das Dokument „{document_name}“ hat keine gültige Dateiendung."
      },
      "upload_image": {
        "file_too_big": "Datei zu groß: maximale Dateigröße ist 5 MB"
      },
      "warning": {
        "multipleFiles": "Dieser Export enthält mehrere ZIP-Dateien. Ihr Browser blockiert möglicherweise mehrere Downloads. Kontaktieren Sie den Ziggu-Support, wenn nur 1 ZIP-Datei heruntergeladen wurde."
      }
    }
  }
}
